/* asiri-slider-fix.js - Correccion definitiva flechas + contador carrusel v2.13
   Fix: al clonar los botones prev/next para reemplazar el listener nativo,
   se perdia tambien la sincronizacion nativa del contador ("1 / 8") y de los
   puntos. Ahora el propio fix recalcula el indice tras cada scroll (por click
   o por swipe) y actualiza el contador, los dots y el estado disabled. */
(function() {
  'use strict';

  function updateCounterAndDots(sc, slider) {
    var items = slider.querySelectorAll('li.slider__slide, li.grid__item');
    if (!items.length) return;
    var slide = items[0];
    var st = window.getComputedStyle(slider);
    var gap = parseInt(st.columnGap || st.gap || '0', 10) || 0;
    var step = slide.offsetWidth + gap;
    if (!step) return;

    var index = Math.round(slider.scrollLeft / step);
    index = Math.max(0, Math.min(index, items.length - 1));

    var counter = sc.querySelector('.slider-counter--current');
    if (counter) counter.textContent = index + 1;

    var dots = sc.querySelectorAll('.slider-counter__link');
    dots.forEach(function(d, i) {
      d.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    var prevBtn = sc.querySelector('.slider-button--prev');
    var nextBtn = sc.querySelector('.slider-button--next');
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= items.length - 1;
  }

  function initSliderFix() {
    document.querySelectorAll('slider-component').forEach(function(sc) {
      var slider = sc.querySelector('ul.slider');
      if (!slider || slider.dataset.asiriFixed === 'true') return;
      slider.dataset.asiriFixed = 'true';

      var prev = sc.querySelector('.slider-button--prev');
      var next = sc.querySelector('.slider-button--next');

      function scrollAmt() {
        var slide = slider.querySelector('li.slider__slide, li.grid__item');
        if (!slide) return slider.offsetWidth / 4;
        var st = window.getComputedStyle(slider);
        var gap = parseInt(st.columnGap || st.gap || '0', 10) || 0;
        return slide.offsetWidth + gap;
      }

      if (prev) {
        var p2 = prev.cloneNode(true);
        prev.parentNode.replaceChild(p2, prev);
        p2.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slider.scrollBy({ left: -scrollAmt(), behavior: 'smooth' });
        });
      }
      if (next) {
        var n2 = next.cloneNode(true);
        next.parentNode.replaceChild(n2, next);
        n2.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slider.scrollBy({ left: scrollAmt(), behavior: 'smooth' });
        });
      }

      var scrollTimer = null;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          updateCounterAndDots(sc, slider);
        }, 100);
      }, { passive: true });

      updateCounterAndDots(sc, slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliderFix);
  } else {
    initSliderFix();
  }
  window.addEventListener('load', initSliderFix);
  setTimeout(initSliderFix, 1500);
})();
